<template>
  <div class="features">
    <div class="header">
      <img
        src="https://images.squarespace-cdn.com/content/5d5a2eb1c8fcf2000111193b/1570944986692-QL1KU6HSFN9ZY5WAZ35D/Game+Mindset+Logo+GW.png?content-type=image%2Fpng"
        alt="mindset"
      >
    </div>
    <div class="container">
      <div class="wrapper">
        <h1>Game Mindset Self-Assessment.</h1>
        <p>
          Mindful Cricket is about one thing that powers a thousand other
          things: MINDSET. No one masters the game of cricket with the wrong
          mindset, and everyone can play better with a Game Mindset.
          <br>
          This questionnaire offers you the opportunity to assess your cricket
          mindset and to identify your perceived strengths, development
          opportunities and potential derailers.
          <br>
          The pages which follow describe the four pillars of the
          <b>Game Mindset – Clear Mind; Play Brave; Play Clever; Play Better.</b>
          <br>
          To complete the questionnaire, just read and reflect on the items on
          each page and rate the extent to which you agree or disagree with each
          statement. Once completed, the final page explains how to analyse your
          results.
        </p>
        <p>
          Note. Be mindful this is a self-assessment, so it offers just one
          perspective on your game. That’s why we recommend getting your Coach
          or a trusted Teammate to offer their insights. This will help you to
          choose the best course of action based on multiple perspectives.
        </p>

        <p class="intro">
          ‘Game Mindset is like the batting stance. It’s simple, balanced and
          gets you game ready. It is the key to playing Mindful Cricket.’
        </p>
        <hr>
        <h3>Instructions</h3>
        <div class="row">
          <div class="col-md-8">
            Reflect on how much you agree or disagree that the statements below
            apply to your cricket game. <br>
            Use the five point rating scale to rate each item and when you have
            completed all the items take time to reflect on strengths,
            development areas and potential derailers.
          </div>
          <div class="col-md-auto">
            <b>Rating Scale</b>
            <p class="legend">
              1. Strongly Disagree <br>
              2. Disagree <br>
              3. Neither Agree or Disagree <br>
              4. Agree <br>
              5. Strongly Agree
            </p>
          </div>
        </div>
        <SurveySection :sections="sections" />
        <!-- <div class="survey-block">
          <h3>Pillar 1. Clear Mind.</h3>
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Composure</th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Question 1</td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="1"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="2"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="3"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="4"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="5"
                  >
                </td>
              </tr>
              <tr>
                <td>Question 2</td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="1"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="2"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="3"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="4"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="5"
                  >
                </td>
              </tr>
              <tr>
                <td>Question 3</td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="1"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="2"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="3"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="4"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="5"
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Focus in the Moment</th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Question 1</td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="1"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="2"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="3"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="4"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="5"
                  >
                </td>
              </tr>
              <tr>
                <td>Question 2</td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="1"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="2"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="3"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="4"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="5"
                  >
                </td>
              </tr>
              <tr>
                <td>Question 3</td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="1"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="2"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="3"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="4"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="5"
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="survey-block">
          <h3>Pillar 2. Play Brave.</h3>
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Bold Vision</th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Question 1</td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="1"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="2"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="3"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="4"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question1"
                    value="5"
                  >
                </td>
              </tr>
              <tr>
                <td>Question 2</td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="1"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="2"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="3"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="4"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question2"
                    value="5"
                  >
                </td>
              </tr>
              <tr>
                <td>Question 3</td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="1"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="2"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="3"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="4"
                  >
                </td>
                <td>
                  <input
                    type="radio"
                    name="question3"
                    value="5"
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->
        <hr>
        <div class="personal-information">
          <h3>Fill in your information</h3>
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <input
                  v-model="form.firstname"
                  class="form-control"
                  placeholder="First name*"
                >
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <input
                  v-model="form.lastname"
                  class="form-control"
                  placeholder="Last name*"
                >
              </div>
            </div>
          </div>
          <div class="form-group">
            <input
              id="exampleInputEmail1"
              v-model="form.email"
              type="email"
              class="form-control"
              aria-describedby="emailHelp"
              placeholder="Email address*"
            >
            <small
              id="emailHelp"
              class="form-text text-muted"
            >We'll never share your email with anyone else.</small>
          </div>

          <div class="form-group">
            <textarea
              id
              v-model="form.remark"
              class="form-control"
              rows="3"
              placeholder="Additional remarks (optional)"
            />
          </div>
          <div class="buttons text-right">
            <b-button
              variant="primary"
              class="primary-button cta cta-full-width-mobile"
              @click="submitClicked"
            >
              Submit
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SurveySection from '@/components/SurveySection';

export default {
  name: "MindfulAssesment",
  components: { SurveySection },
  data() {
    return {
      form: {
        firstname: '', 
        lastname: '', 
        email: '', 
        remark: ''
      },
      sections: [
        {
          title: "Pillar 1. Clear Mind.",
          parts: [
            {
              title: 'Composure',
              questions: [
                {
                  question: 'Calm and poised in tense moments',
                  value: ''
                },
                {
                  question: 'Patient when faced with frustrations and setbacks',
                  value: ''
                },
                {
                  question: 'Accepting of the ups and downs of cricket and life',
                  value: ''
                }
              ]
            },
            {
              title: 'Focus in the Moment',
              questions: [
                {
                  question: 'Stay focused on one ball at a time when batting',
                  value: ''
                },
                {
                  question: 'Reset concentration when distracted',
                  value: ''
                },
                {
                  question: 'Sustain concentration when bowling, keeping or fielding',
                  value: ''
                }
              ]
            },
                        {
              title: 'Keep it Simple',
              questions: [
                {
                  question: 'Do the basics under pressure',
                  value: ''
                },
                {
                  question: 'Keep a clear and uncluttered mind',
                  value: ''
                },
                {
                  question: 'Put pressure back on opponents',
                  value: ''
                }
              ]
            },
            {
              title: 'Adapt Fast',
              questions: [
                {
                  question: 'Adapt quickly to new conditions',
                  value: ''
                },
                {
                  question: 'Think on feet as situations unfold',
                  value: ''
                },
                {
                  question: 'Agile in applying new tactics and strategies',
                  value: ''
                }
              ]
            }
          ]
        },
         {
          title: "Pillar 2. Play Brave.",
          parts: [
            {
              title: 'Bold Vision',
              questions: [
                {
                  question: 'Have bold aspirations that really motivate me',
                  value: ''
                },
                {
                  question: 'Have clear, challenging but attainable mid-term goals',
                  value: ''
                },
                {
                  question: 'Have action plans to meet the goals',
                  value: ''
                }
              ]
            },
            {
              title: 'Put it on the Line',
              questions: [
                {
                  question: 'Tend to go towards success rather than avoid failure',
                  value: ''
                },
                {
                  question: 'Reliably apply the basics in moments that matter',
                  value: ''
                },
                {
                  question: 'Willing to take risks, make mistakes and learn',
                  value: ''
                }
              ]
            },
                        {
              title: 'Hold the Tension',
              questions: [
                {
                  question: 'Act with patience and good judgment in key moments',
                  value: ''
                },
                {
                  question: 'Understand and positively shape the momentum of matches',
                  value: ''
                },
                {
                  question: 'Show persistence when things get tough',
                  value: ''
                }
              ]
            }
          ]
        },
         {
          title: "Pillar 3. Play Clever. ",
          parts: [
            {
              title: 'Bat Smart',
              questions: [
                {
                  question: 'Have trust to do the batting basics well in all situations',
                  value: ''
                },
                {
                  question: 'Contribute to batting partnerships',
                  value: ''
                },
                {
                  question: 'Absorb and apply pressure when batting',
                  value: ''
                }
              ]
            },
            {
              title: 'Bowl Smart',
              questions: [
                {
                  question: 'Have trust to do the bowling basics well in all situations',
                  value: ''
                },
                {
                  question: 'Play my role in bowling partnerships',
                  value: ''
                },
                {
                  question: 'Absorb and apply pressure when bowling',
                  value: ''
                }
              ]
            },
                        {
              title: 'Keep and Field Smart',
              questions: [
                {
                  question: 'Do the fielding basics well in all situations',
                  value: ''
                },
                {
                  question: 'Contribute to the team effort in the field',
                  value: ''
                },
                {
                  question: 'Bring a positive mindset onto the field',
                  value: ''
                }
              ]
            }
          ]
        },
        {
          title: "Pillar 4. Play Better.",
          parts: [
            {
              title: 'Apply a Growth Mindset',
              questions: [
                {
                  question: 'Believe improvement comes from work not just talent',
                  value: ''
                },
                {
                  question: 'Openly seek and receive feedback even if it stings a bit',
                  value: ''
                },
                {
                  question: 'Take good care of physical and mental wellbeing',
                  value: ''
                }
              ]
            },
            {
              title: 'Be Game Ready ',
              questions: [
                {
                  question: 'Have good daily habits and disciplines',
                  value: ''
                },
                {
                  question: 'Know how to prepare to play',
                  value: ''
                },
                {
                  question: 'Consistently apply pre-game routines and rituals ',
                  value: ''
                }
              ]
            },
                        {
              title: 'Bring Optimism ',
              questions: [
                {
                  question: 'Confront difficult situations with an optimistic mindset',
                  value: ''
                },
                {
                  question: 'Use positive words and language when thinking and talking',
                  value: ''
                },
                {
                  question: 'Feel grateful for the positive things in life',
                  value: ''
                }
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {    
    isValid(){
      let questionValid = [];
      this.sections.map(section => section.parts.map(part => part.questions.map( question => {
        if(question.value && parseInt(question.value) > 0 && parseInt(question.value) <=5){
          questionValid.push(true)
          return;
        }
        questionValid.push(false)
      })))
      if (this.form.email && this.validateEmail(this.form.email) && this.form.firstname && this.form.lastname && this.form.firstname.length && this.form.lastname.length && !questionValid.some(a => a === false)){
        return true;
      }
      return false
    }
    },
  mounted() {
    // Tracking code
    // this.$ma.trackEvent({
    //   fb_event: "ViewContent",
    //   category: "Request_Demo",
    //   action: "Request_Demo",
    //   label: "DEMO",
    //   type: "DEMO"
    // });
  },
  methods:{
    validateEmail(email) {
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    makeToast(title, message, variant = null) {
        this.$bvToast.toast(message, {
          title:  title, 
          variant: variant,
          solid: true
        })
      },
    submitClicked(){
      if(this.isValid){
        // alert('Valid form')
        this.makeToast('Success', `Form is completed!! An email with form data is send to ${this.form.email}`, 'success')
      // this.sections.map(section => section.parts.map(part => part.questions.map( question => {
      //   console.log(section.title, part.title, question.question, '->', question.value);
      // })))
      } else {
        // alert('Not valid form')
        this.makeToast('Error', 'Form is nont valid', 'danger')
      }
      
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  background: #fff;
  padding: 10px;
  text-align: center;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);

  img {
    max-width: 100px;
  }
}
.wrapper {
  margin: 20px auto;
}
p {
  &.intro {
    font-size: 16px;
    padding: 20px;
    background: #000;
    color: #fff;
    text-align: center;
    margin: 40px auto;
    border-radius: 30px 0 30px 0;
    max-width: 700px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
  }
  &.legend {
    font-size: 12px;
    line-height: 20px;
  }
}
.survey-block {
  + .survey-block {
    margin-top: 50px;
  }
}
.table {
  color: #2b3060;
  margin-bottom: 30px;
  table-layout: fixed;
}
.table th {
  border-top: none !important;
  width: 1px;
  &:nth-child(1) {
    width: 200px;
  }
}
</style>
